import { call, put, select } from 'redux-saga/effects';
import { WEB_SERVICES } from "./webServices";
import { pinValidate } from '@bitComponents/adabyron/manager';

const contextStore = state => state.context.data;

export function* validateOBDPin(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
    validateOBDPinData,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(pinValidate, validateOBDPinData, context);

    if (successUpdate) {
      yield put(successUpdate(response));
    }

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.PIN_VALIDATE, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
